<script setup lang="ts">
import { type ITarget, ServiceTypes } from '@types';
import { Styles } from '@ui/styles';

const props = withDefaults(defineProps<{
  title?: string;
  targets?: ITarget[];
  type?: ServiceTypes;
}>(), {
  title: '',
  targets: () => [],
});

const model = ref();

const sortedTargets = computed(() => [...props.targets].sort((a, b) => a.id - b.id));
defineEmits(['update:target']);
</script>

<template lang="pug">
.flex.col-24.p-24.w-100p.max-w-376.m-auto
  .title.typ-20-28-600(v-if="title") {{ title }}
  UiInputSelect(
    v-model="model"
    labelProp="name"
    :label="`page.booking.service.target.form.field.${type === ServiceTypes.Rent ? 'target' : 'group_target'}.label`"
    :placeholder="`page.booking.service.target.form.field.${type === ServiceTypes.Rent ? 'target' : 'group_target'}.placeholder`"
    :searchable="false"
    :size="Styles.Sizes.Large"
    :options="sortedTargets"
    :valueAsObject="true"
  )
  UiButton(
    label="page.booking.service.target.button.booking.text"
    :disabled="!model"
    @click="$emit('update:target', model)"
  )
</template>

<style scoped lang="scss">
.title {
  color: #1f1f1f;
}
</style>